/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import axios from 'axios';
import { getCurrentSubdomain } from './Subdomain';
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = async ({ secure, path, type, query, format, body, ...params }) => {
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            const URL_SUBDOMAIN = getCurrentSubdomain();
            if (type === ContentType.FormData &&
                body &&
                body !== null &&
                typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                const formData = this.createFormData(body);
            }
            return this.instance.request({
                ...requestParams,
                headers: {
                    ...(type && type !== ContentType.FormData
                        ? { 'Content-Type': type }
                        : {}),
                    ...(requestParams.headers || {}),
                    ...({ 'X-Product': URL_SUBDOMAIN }),
                },
                params: query,
                responseType: responseFormat,
                data: body,
                url: path,
            });
        };
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || '',
            withCredentials: true,
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.instance.defaults.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
/**
 * @title Phoenix API
 * @version 1.0.0@dev
 *
 * New structure for OPEN API
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.api = {
            /**
             * @description SG Locate address lookup
             *
             * @tags Address
             * @name SgLocate
             * @summary SG Locate address lookup
             * @request POST:/api/v1/address/lookup
             * @secure
             * @response `200` `(V1AddressAddressLookup)[]` Success
             * @response `500` `V1ServerError` Server error
             */
            sgLocate: (data, params = {}) => this.request({
                path: `/v1/address/lookup`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Country
             * @name Countries
             * @summary Countries
             * @request GET:/api/v1/country/countries
             * @secure
             * @response `200` `(V1CountryCountry)[]` Countries
             */
            countries: (params = {}) => this.request({
                path: `/v1/country/countries`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Country
             * @name CountryCodes
             * @summary Phone country codes
             * @request GET:/api/v1/country/country-codes
             * @secure
             * @response `200` `(V1CountryCountryCode)[]` Phone country codes
             */
            countryCodes: (params = {}) => this.request({
                path: `/v1/country/country-codes`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * @description You can accept any consent here
             *
             * @tags Customer
             * @name CustomerCreate
             * @summary Accept consent
             * @request POST:/api/v1/customer/{customerUuid}
             * @secure
             * @response `201` `void` Created
             * @response `422` `V1ValidationFailed` Validation failed
             * @response `500` `V1ServerError` Server error
             */
            customerCreate: (customerUuid, data, params = {}) => this.request({
                path: `/v1/customer/${customerUuid}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * No description
             *
             * @tags Inventory
             * @name FindSkusByCodeGet
             * @summary Finding SKUS by code
             * @request GET:/api/v1/inventory/skus/{code}/{organisationId?}
             * @secure
             * @response `200` `(V1InventorySKUSkusList)[]` SKUS list
             */
            findSkusByCodeGet: (code, organisationId, params = {}) => this.request({
                path: `/v1/inventory/skus/${code}/{organisationId?}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Inventory
             * @name SkuDetailsGet
             * @summary Get SKU details
             * @request GET:/api/v1/inventory/sku/details/{uuid}
             * @secure
             * @response `200` `(V1InventorySKUSkuDetails)[]` SKUS list
             */
            skuDetailsGet: (uuid, params = {}) => this.request({
                path: `/v1/inventory/sku/details/${uuid}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Messages
             * @name GetMessages
             * @summary Get messages after given date
             * @request GET:/api/v1/messages
             * @secure
             * @response `200` `({ uuid?: string, subject?: string, subtitle?: string, publishDate?: string, typeName?: string, typeIconUrl?: string })[]` User messages
             * @response `401` `{ message?: string }` Unauthorized
             */
            getMessages: (query, params = {}) => this.request({
                path: `/v1/messages`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Messages
             * @name GetMessage
             * @summary Get message by Uuid
             * @request GET:/api/v1/message
             * @secure
             * @response `200` `({ uuid?: string, subject?: string, subtitle?: string, content?: string, iconUrl?: string, bannerUrl?: string, ctaLink?: string, ctaTitle?: string, publishDate?: string, typeName?: string, typeIconUrl?: string })[]` User message
             * @response `401` `{ message?: string }` Unauthorized
             * @response `404` `{ message?: string }` Message not found
             */
            getMessage: (query, params = {}) => this.request({
                path: `/v1/message`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Messages
             * @name ClearAllMessages
             * @summary Celar all messages
             * @request GET:/api/v1/message/clear-all
             * @secure
             * @response `200` `{ message?: string }` Messages cleared
             * @response `401` `{ message?: string }` Unauthorized
             */
            clearAllMessages: (params = {}) => this.request({
                path: `/v1/message/clear-all`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Settings
             * @name GetSingleSetting
             * @summary Getting defined publically accessible settings
             * @request GET:/api/v1/settings/{key}
             * @secure
             * @response `200` `string` Value of setting
             * @response `404` `void` Key not accessible or not found
             */
            getSingleSetting: (key, params = {}) => this.request({
                path: `/v1/settings/${key}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Settings
             * @name GetAllSettings
             * @summary Getting all publically accessible settings
             * @request GET:/api/v1/settings
             * @secure
             * @response `200` `(string)[]` Value of setting
             * @response `404` `void` Key not accessible or not found
             */
            getAllSettings: (params = {}) => this.request({
                path: `/v1/settings`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Order
             * @name GetAllOrders
             * @summary Getting all orders
             * @request GET:/api/v1/order/all
             * @secure
             * @response `200` `{ data?: (V1OrderOrderData)[], meta?: (V1Pagination)[] }` Orders
             * @response `401` `{ message?: string }` Unauthorized
             */
            getAllOrders: (query, params = {}) => this.request({
                path: `/v1/order/all`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Order
             * @name GetOrders
             * @summary Getting all orders only from selected sales channel
             * @request GET:/api/v1/order/all/{salesChannelKey}
             * @secure
             * @response `200` `{ data?: (V1OrderOrderData)[], meta?: (V1Pagination)[] }` Orders
             * @response `401` `{ message?: string }` Unauthorized
             */
            getOrders: ({ salesChannelKey, ...query }, params = {}) => this.request({
                path: `/v1/order/all/${salesChannelKey}`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * @description Creating order
             *
             * @tags Order
             * @name OrderCreate
             * @summary Create
             * @request POST:/api/v1/order/
             * @secure
             * @response `201` `{ id?: string, customerUuid?: string }` Created
             * @response `422` `V1ValidationFailed` Validation failed
             * @response `500` `V1ServerError` Server error
             */
            orderCreate: (data, params = {}) => this.request({
                path: `/v1/order/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Order
             * @name GetOrderDetails
             * @summary Getting order details
             * @request GET:/api/v1/order/details/{uuid}
             * @secure
             * @response `200` `V1OrderDetailsSchema` Order details
             */
            getOrderDetails: (uuid, params = {}) => this.request({
                path: `/v1/order/details/${uuid}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Payment
             * @name GetPaymentMethodsList
             * @summary Getting all payment methods are only them connected to selected salesChannel
             * @request GET:/api/v1/payment/methods/{salesChannelKey}
             * @secure
             * @response `200` `V1PaymentPaymentMethodSchema` PaymentMethods
             * @response `404` `V1NotFound` Sales channel with given system key does not exist.
             */
            getPaymentMethodsList: (salesChannelKey, params = {}) => this.request({
                path: `/v1/payment/methods/${salesChannelKey}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Payment
             * @name CreatePaynowPayment
             * @summary Create paynow payment
             * @request POST:/api/v1/payment/paynow/{order}/{salesChannel}
             * @secure
             * @response `201` `V1PaymentPaynow` PaymentMethods
             * @response `404` `V1NotFound` Sales channel with given system key does not exist.
             */
            createPaynowPayment: (order, salesChannel, params = {}) => this.request({
                path: `/v1/payment/paynow/${order}/${salesChannel}`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * @description Getting pricing informations for given variant
             *
             * @tags Pricing
             * @name PricingForVariantGet
             * @summary Get pricing for variant
             * @request GET:/api/v1/pricing/{variantUuid}
             * @secure
             * @response `200` `V1Pricing` Pricing
             * @response `404` `V1NotFound` Not found
             */
            pricingForVariantGet: ({ variantUuid, ...query }, params = {}) => this.request({
                path: `/v1/pricing/${variantUuid}`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * @description Getting pricing informations for given product unit
             *
             * @tags Pricing
             * @name PricingForProductUnitGet
             * @summary Get pricing for product unit
             * @request GET:/api/v1/pricing/{unitUuid}/unit
             * @secure
             * @response `200` `V1Pricing` Pricing
             * @response `404` `V1NotFound` Not found
             */
            pricingForProductUnitGet: ({ unitUuid, ...query }, params = {}) => this.request({
                path: `/v1/pricing/${unitUuid}/unit`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Catalog
             * @name CatalogListGet
             * @summary Getting list of product catalogs
             * @request GET:/api/v1/catalog
             * @secure
             * @response `200` `(V1ProductCatalog)[]` List of catalogs
             * @response `401` `V1NonAuthorized` No authorized
             */
            catalogListGet: (params = {}) => this.request({
                path: `/v1/catalog`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Catalog
             * @name CatalogGet
             * @summary Show product catalog
             * @request GET:/api/v1/catalog/{catalogUuid}
             * @secure
             * @response `200` `V1ProductCatalog` Catalog
             * @response `401` `V1NonAuthorized` No authorized
             * @response `404` `V1NotFound` Catalog not found
             */
            catalogGet: (catalogUuid, params = {}) => this.request({
                path: `/v1/catalog/${catalogUuid}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Product
             * @name ProductListByCatalogGet
             * @summary Getting products in catalog
             * @request GET:/api/v1/product/by-catalog/{catalogUuid}
             * @secure
             * @response `200` `(V1ProductProduct)[]` Products
             * @response `404` `V1NotFound` Catalog not found
             */
            productListByCatalogGet: (catalogUuid, params = {}) => this.request({
                path: `/v1/product/by-catalog/${catalogUuid}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Product
             * @name ProductAdvancedDescriptionCreate
             * @summary Adding advanced description sections to product
             * @request POST:/api/v1/product/advanced-description/{productUuid}
             * @secure
             * @response `201` `void` Description added!
             * @response `400` `V1BadRequest` Missing 'sections' field!
             * @response `404` `V1NotFound` Product with given uuid does not exist
             * @response `422` `V1BadRequest` The given data was invalid.
             */
            productAdvancedDescriptionCreate: (productUuid, params = {}) => this.request({
                path: `/v1/product/advanced-description/${productUuid}`,
                method: 'POST',
                secure: true,
                ...params,
            }),
            /**
             * @description Order discount preview
             *
             * @tags Order
             * @name OrderDiscountPreview
             * @summary Discount Preview
             * @request POST:/api/v1/order/promo/discount-preview
             * @secure
             * @response `200` `V1OrderPromoOrderPromoPreviewSchema` Discount check
             * @response `400` `V1OrderPromoOrderPromoPreviewBadRequestSchema` Promo Code exception
             * @response `422` `V1ValidationFailed` Validation failed
             * @response `500` `V1ServerError` Server error
             */
            orderDiscountPreview: (data, params = {}) => this.request({
                path: `/v1/order/promo/discount-preview`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
            /**
             * No description
             *
             * @tags Shipping
             * @name GetShippingMethods
             * @summary Getting shipping methods for sales channel
             * @request GET:/api/v1/shipping/methods/{salesChannelKey}
             * @secure
             * @response `200` `V1ShippingMethods` Shipping Methods
             * @response `404` `V1NotFound` Sales channel with given system key does not exist.
             */
            getShippingMethods: (salesChannelKey, params = {}) => this.request({
                path: `/v1/shipping/methods/${salesChannelKey}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
        };
    }
}
